import styles from 'styles/NavLinkColor.module.css'

const NavLinkButton = ({ onClick, color, children, ...rest }) => (
    <button onClick={onClick} className={`${styles.navlink} ${styles[color]}`} {...rest}>
        { children }
    </button>
)

export default NavLinkButton